export function gaSendEvent (category, action, label) {
  if (window && window.ga) {
    window.ga('send', 'event', category, action, label || null)
  }
}
